import script from "./POIList.vue?vue&type=script&setup=true&lang=jsx"
export * from "./POIList.vue?vue&type=script&setup=true&lang=jsx"

import "./POIList.vue?vue&type=style&index=0&id=4eb1ddf3&lang=scss&scoped=true"

import exportComponent from "/home/gitlab-runner/builds/RJKESzs2/0/roolz/poi-manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4eb1ddf3"]])

export default __exports__